import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import * as global from '../../../../global';
import { WoundService } from 'src/app/services/wound.service';
import { HttpResponse } from '@angular/common/http';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PatientListService } from 'src/app/includes/patient-list/patient-list-service';
import { WoundCareWidgetService } from 'src/app/includes/note-sidebar/wound-care-widget/wound-care-widget.service';
import { MergePatientsService } from 'src/app/includes/merge-patients/merge-patients.service';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardService } from 'src/app/includes/dashboard/dashboard.service';
import { TranscriptionCreateService } from 'src/app/includes/transcription-create/transcription-create.service';
import { FormControl } from '@angular/forms';
import { Observable, lastValueFrom } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SnfWcNurseAssociationService } from 'src/app/includes/snf_wc_nurse-snf_wc_nurse-association/snf_wc_nurse_association.service';

interface IFilter {
  active: boolean,
  patientName: string,
  dob: String,
  facility?: String,
  provider?: any,
  dn_mrnNo?: String,
  pcc_mrnNo?: String
  // index: String,
}
@Component({
  selector: 'app-tissue-analytic-report',
  templateUrl: './tissue-analytic.component.html',
  styleUrls: ['./tissue-analytic.component.css']
})
export class TissueAnalyticReportComponent implements OnInit {
  loader_id = "app-wound-report";
 
  companyId: any;
  patients: any = [];
  selectedWounds: any = [];
  patient: any = "";
  searchTextProvider: any;
  readOnlyMode = true;
  facilities: Array<any> = [];
  assocProviders: Array<any> = [];
  filter: IFilter;
  currentUser: any;
  providerID: any;
  facilityID: any;
  woundState: string = 'active';
  companySide: boolean;
  loadWounds: boolean = false;
  nursingSide: boolean;
  user_dashboard: Boolean = false;
  facilityControl = new FormControl();
  filteredFacilities: Observable<string[]>;
  nurseAssociatedFacilities: Array<any> = [];
  selectedFacilityId;
  isSnfNurse: boolean = false;
  selectable: boolean = false; 
  
  constructor(
    // private _facilityService: FacilityService,
    private loader: NgxUiLoaderService,
    private _location: Location,
    private patinetService: PatientListService,
    private woundCareWidgetService: WoundCareWidgetService,
    private _route: ActivatedRoute,
    private woundService: WoundService,
    private mergePatientService: MergePatientsService,
    private authService: AuthService,
    private _dashboardService: DashboardService,
    private _transcriptionCreateService: TranscriptionCreateService,
    private _snfWcNurseAssociationService: SnfWcNurseAssociationService
  ) {
    this.companyId = this._route.parent.snapshot.params.id;
    this.currentUser = this.authService.currentUser;
    if (this._route.parent.snapshot.params.id) {
      this.companySide = true;
    } else {
      this.companyId = this.currentUser.company_id;
    }
    if(window.location.pathname.includes('dashboard')){
      this.user_dashboard = true;
    }
    if(window.location.pathname.includes('nursing')){
      this.nursingSide=true;
    }
    if (this.currentUser.user_type === global.USER_TYPE.SNF_WC_NURSE) {
      this.isSnfNurse = true;
    }
  }
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////All Comment Code is for facility filter///////////////// 
  //////////////////////////////////////////////////////////////////////////////
  async ngOnInit(): Promise<void> {
    // this.filter.provider = ""
    console.log("current user", this.currentUser);
    if (this.isSnfNurse) {
      await this.initFacilities();
      this.selectDefaultFacility();
    }
    this._transcriptionCreateService.getFacilitiesByCompanyID(this.companyId).subscribe((data: any) => {
      if (data.status == 200) {
        this.facilities = this.sortTitleVise(data.facilities)
      }
      else {

      }

    })
    // await this.initAssocProviders();
    // console.log("associate provider", this.assocProviders);
    // this.getPatients(this.companyId);
    this.filteredFacilities = this.facilityControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterFacilities(value)));
  }
  private filterFacilities(value: string): string[] {
    if (value) {
      const filterValue = value.toLowerCase();
      return this.nurseAssociatedFacilities.filter(option => option.title.toLowerCase().indexOf(filterValue) > -1);
    }
    else {
      return this.nurseAssociatedFacilities;
    }
  }
  selectDefaultFacility() {
    if (this.nurseAssociatedFacilities.length > 0) {
      this.facilityControl.setValue(this.nurseAssociatedFacilities[0].title);
      this.selectedFacilityId = this.nurseAssociatedFacilities[0]._id
    }
  }
  async initFacilities() {
    const filter = {
      associated_snf_wc_nurse_ids: this.currentUser._id,
    };
    const nurseProjection = {
      first_name: 1,
      last_name: 1,
      title: 1,
    };
    const facilityProjection = {
      title: 1,
      pcc_facId: 1,
      pcc_2_legged_authentication: 1,
      source: 1
    };
    if (this.isSnfNurse) {
      const response: any = await lastValueFrom(this._snfWcNurseAssociationService.getFacilityAssociatedSnfWcNurses(filter, nurseProjection, facilityProjection));
      if (response.status === 200 && response.data.length > 0) {
        this.nurseAssociatedFacilities = response.data;
        this.nurseAssociatedFacilities.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
      }
    }
  }
  onSelectFacility(facility, patientSearch) {
    this.selectedFacilityId = facility._id;
    this.patients = [];
  }

  sortFirstNameVise(arrayTosort) {
    let users = arrayTosort;
    let result = users.sort(function (a, b) {
      if (a.first_name?.toLowerCase() < b.first_name?.toLowerCase()) { return -1; }
      if (a.first_name?.toLowerCase() > b.first_name?.toLowerCase()) { return 1; }
      return 0;
    })
    return result;
  }

  getPatients(companyId, facilityId) {
    this.loader.startLoader(this.loader_id)
    this.patinetService.getPatientsV2(companyId, facilityId).subscribe((data: any) => {
      this.patients = data.data.array;
      console.log("patients", data.data.array)
      // this.patients = data.data.array.filter(patient => patient.first_name === 'Burt');
      this.loader.stopLoader(this.loader_id);
      // this.patients = data.data.array;
    })
  }

  async handleProviderChange(id) {
    console.log("id", id);
    this.woundService.getProviderWounds(id).subscribe((data: any) => {
      this.selectedWounds = data.wounds
      console.log("wounds", data);
    })
  }


  handleFacilityChange(event) {
    console.log("facility id", event);
    this._transcriptionCreateService.getAssocProviders(event).subscribe((data: any) => {
      console.log("facility data", data);
      this.assocProviders = this.sortFirstNameVise(data.facility.provider_ids_ref);
    })
    // this.getPatients(this.companyId, this.facilityID);
  }

  sortTitleVise(arrayTosort) {
    let users = arrayTosort;
    let result = users.sort(function (a, b) {
      if (a.title?.toLowerCase() < b.title?.toLowerCase()) { return -1; }
      if (a.title?.toLowerCase() > b.title?.toLowerCase()) { return 1; }
      return 0;
    })
    return result;
  }

  isPCCFacility(facility_id) {
    for (const facility of this.facilities) {
      if (facility_id === facility._id) {
        if (facility.pcc_facId) {
          return true;
        }
      }
    }
  }
  isMatrixFacility(facility_id) {
    for (const facility of this.facilities) {
      if (facility_id === facility._id) {
        if (facility.source == 'MatrixCare') {
          return true;
        }
      }
    }
  }

  selectPatient(data) {
    // console.log("data", data.option.value);
    console.log("comming patient", data);

    this.loadWounds = false;
    this.selectedWounds = [];
    this.patient = data;
    if (this.patient.facilityObject[0].timeZone) {
      this.patient['timeZone'] = this.patient.facilityObject[0].timeZone;
    }
    else {
      this.patient['timeZone'] = 'America/New_York';
    }
    this.loadWounds = true;
    // this.initWounds(this.patient._id);

  }

  goBack() {
    this._location.back();
  }
  wound: any;
  woundDetails: boolean = false;
  woundAnalyticReport(event) {
    this.wound = event;
    this.woundDetails = true;
  }

  async downloadPDF() {
    this.woundService.exportWoundAsPdf(this.wound._id, this.patient).
      subscribe((data: any) => {
        // this.wound.child_wounds = child_wounds;
        console.log(data);
        if (data instanceof HttpResponse) {
          console.log("in httpresponse")
          var url = window.URL.createObjectURL(data.body);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = 'Wound Post Rounds Report.pdf';
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
        }
        else {
          console.log("in else")
          if (data.type === 0) {
          } else if (data.type === 3) {
            const { loaded, total } = data;
            const progress = Math.round(loaded / total * 100);
            if (progress > 0) {
            }
          }
        }
        if (data.status == 200) {
          console.log("in status")
          return true;
        }

      }
      )
  }

  searchPatients(name) {
    this.loadWounds = false;
    this.woundDetails = false;
    if ((name.trim()).length < 4) {
      this.loadWounds = false;
      this.patient = "";
      return;
    }
    if (name !== null && typeof name === 'object') {
      console.log("namee :is object: ", name);
      this.loadWounds = false;
      this.patient = name;
      console.log("selected patient", this.patient)
      let patient_one = name;
      // let filters["patient_id"]: any = this.patient?._id;
      // this.getPatientCharges(1, null);
      return;
    }
    name = name?.replace(',', '');
    if (name.length < 4) {
      return;
    }
    // this.toastr.info('Fetching Patients', 'Wait....');

    let filter1 = {
      first_name: '',
      last_name: ''
    }
    filter1.first_name = name?.trim().split(" ")[0]?.trim();
    filter1.last_name = name?.trim().split(" ")[1]?.trim();

    if (this.isSnfNurse) {
      let newFilter = {
        ...filter1,
        facility_id: this.selectedFacilityId
      }
      this.mergePatientService.searchThePatientOnly(newFilter, true)
        .subscribe((patientsResponse: any) => {
          this.patients = patientsResponse.data;
        })
    } else {
      this.mergePatientService.searchThePatientOnly(filter1)
        .subscribe((patientsResponse: any) => {

          this.patients = patientsResponse.data;
          // console.log('patients', this.patients);
        })
    }
  }
  displayPatientFn(patient): string {
    this.patient = patient;
    // console.log("selected patient", this.patient)
    return patient && patient.first_name ? patient.first_name + " " + patient.last_name : '';
  }

  generateReportForAllWounds() {
    console.log("selected patient", this.patient);
    this.woundCareWidgetService.generateReportForAllWounds(this.patient, "active").subscribe((data: any) => {
      if (data instanceof HttpResponse) {
        console.log("in httpresponse")
        var url = window.URL.createObjectURL(data.body);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = 'DocNow Wound Post Rounds Report.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }
      else {
        console.log("in else")
        if (data.type === 0) {
        } else if (data.type === 3) {
          const { loaded, total } = data;
          const progress = Math.round(loaded / total * 100);
          if (progress > 0) {
          }
        }
      }
      if (data.status == 200) {
        console.log("in status")
        return true;
      }
    })
  }


}
